import { Button, styled } from '@mui/material'

export const ButtonRound = styled(Button)(
  ({ radius }) => ({
    borderRadius: radius || 21
  })
)
